import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable, of, switchMap, take } from 'rxjs';

import {
  EndUserLicenseAgreementService,
  EndUserLicenseAgreement,
} from '../end-user-license-agreement/end-user-license-agreement.service';
import { AuthenticationService } from '../auth/authentication.service';

export const eulaGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const auth = inject(AuthenticationService);
  const eula = inject(EndUserLicenseAgreementService);

  return auth.boabaasUser$.pipe(
    take(1),
    switchMap((user) => {
      if (user.isAdmin) {
        return of(true);
      }

      return eula.hasAgreed().pipe(
        switchMap((hasAgreed) => {
          if (hasAgreed) return of(true);

          return eula.retrieve().pipe(
            map((result: EndUserLicenseAgreement) => {
              if (result) {
                return router.createUrlTree(['/end-user-license-agreement']);
              }
              return true;
            }),
          );
        }),
      );
    }),
  );
};
